<template>
	<div style="padding: 20px 20px 20px 0;">
		<div style="text-align: right;margin-right: 50px;">
			<el-button size="mini" @click="goBack" type="primary">返回</el-button>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="基本信息" name="first">
				<div class="infos">
					<div style="display: flex;justify-content: space-between;padding: 10px;width: 70%;">
						<!-- 	{{form}} -->
						<div class="infoDetail">

							<div>所属楼层:{{ form.storey }}</div>
							<div>商铺编号:{{ form.shopNum }}</div>
							<div>商户名称:{{ form.zsContractEntity.merchantName }}</div>
							<div>名称:{{ form.brandName }}</div>
							<div>出租面积:{{ form.zsContractEntity.rentalArea }}</div>
							<div>经营状态:{{ form.zsContractEntity.shopFormat }}</div>
							<div>联系人:{{ form.linkPhone }}</div>
							<div>联系人身份证号:{{ form.linkCard }}</div>
							<div>联系电话:{{ form.linkPhone }}</div>
							<div>合同号:{{ form.zsContractEntity.contractCode }}</div>
							<div>合同编号:{{ form.zsContractEntity.contractInCode }}</div>
							<div>开始日期:{{ form.zsContractEntity.beginDate }}</div>
							<div>结束日期:{{ form.zsContractEntity.endDate }}</div>
							<div>开业时间:{{ form.zsContractEntity.openDate }}</div>
						</div>
						<div class="infoDetail2">
							<div>装修免租期开始日期:{{ form.zsContractEntity.decoFreeRentBegin }}</div>
							<div>装修免租期结束日期:{{ form.zsContractEntity.decorationFreeRent }}</div>
							<div style="display:flex">经营免租期:
								<div>
									<div class="infoDetail22" v-for="item in form.zsContractEntity.openFreeRentTimess">
										{{ item }}
									</div>
								</div>

							</div>
							<div>免租率:{{ form.zsContractEntity.freeRentRatio }}</div>
							<div>装修期物业费(元):{{ form.zsContractEntity.decorationPropertyFee }}</div>
							<div>装修保证金(元):{{ form.zsContractEntity.decorationDeposit }}</div>
							<div>租金收取方式:{{ form.zsContractEntity.rentType }}</div>
							<div>提成比例(营业额):{{ form.zsContractEntity.commissionPercentage }}</div>
						</div>
						<div class="infoDetail">
							<div>租金(元/m³天):{{ form.zsContractEntity.rent }}</div>
							<div>物业费(元/m³天):{{ form.zsContractEntity.propertyFee }}</div>
							<div>推广费(元/m³天):{{ form.zsContractEntity.promotionFee }}</div>
							<div>履约保证金(元):{{ form.zsContractEntity.performanceBond }}</div>
							<div>合同计租日:{{ form.zsContractEntity.rentBeginDate }}</div>
							<div>合同交付日:{{ form.zsContractEntity.deliveryDate }}</div>
							<div>付款周期(自然月):{{ form.zsContractEntity.paymentCycle }}</div>
							<div>发票抬头:{{ form.zsContractEntity.invoiceHand }}</div>
							<div>纳税人识别号:{{ form.zsContractEntity.dutyParagraph }}</div>
							<div>商铺状态:{{ form.status }}</div>
						</div>
						<div class="infoDetail">
							<div>水仪表编码:{{ form.waterCode }}</div>
							<div>电仪表编码:{{ form.electricityCode }}</div>
							<div>银行卡号:{{ form.bankNum }}</div>
						</div>
					</div>
					<div style="display: flex;justify-content: space-between;padding: 10px;">
						<div class="infoDetail">
							<h3>账户信息</h3>
							<div>卡号:{{ form.cardNo }}</div>
							<div>余额:{{ form.balance }}</div>
							<div>付款二维码</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="账单信息" name="second">
				<el-form :model="selectForm" :inline="true">
					<el-form-item label="交易/提现记录">
						<el-select v-model="selectForm.recordType">
							<el-option value="recordOfConsume" label="账户交易明细"></el-option>
							<el-option value="提现申请记录" label="提现申请记录"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-table v-if="selectForm.recordType == 'recordOfConsume'" :data="tableData">
					<el-table-column prop="totalPrice" label="交易金额"></el-table-column>
					<el-table-column prop="payTime" label="交易时间">
						<template slot-scope="{row}">
							{{ setTime(row.payTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="orderNum" label="交易流水号"></el-table-column>
					<el-table-column prop="payWay" label="交易方式">

					</el-table-column>
					<el-table-column prop="payPurpose" label="备注说明"></el-table-column>
				</el-table>
				<el-table v-if="selectForm.recordType == '提现申请记录'" :data="tableData">
					<el-table-column label="提现金额"></el-table-column>
					<el-table-column label="提现银行卡"></el-table-column>
					<el-table-column label="申请时间"></el-table-column>
					<el-table-column label="申请结果"></el-table-column>
					<el-table-column label="到账时间"></el-table-column>
					<el-table-column label="交易流水号"></el-table-column>
				</el-table>
			</el-tab-pane>
			<!-- <el-tab-pane label="营收情况" name="third">
				<el-table :data="tableData2">
					<el-table-column prop="shopName" label="店铺名称"></el-table-column>
					<el-table-column prop="num" label="营业收入"></el-table-column>
					<el-table-column prop="salesDate" label="营收时间"></el-table-column>
					<el-table-column prop="enteringPerson" label="录入人"></el-table-column>
					<el-table-column prop="time" label="录入时间"></el-table-column>
				</el-table>
			</el-tab-pane> -->
		</el-tabs>
		<!-- <div class="info">基本信息</div> -->
		<!-- <div class="info">账单信息</div> -->
		<!-- <div class="info">营收情况</div> -->

	</div>
</template>

<script>
export default {
	data() {
		return {
			activeName: "first",
			selectForm: {
				userId: '',
				oneCardNum: '',
				recordType: 'recordOfConsume',
				currentPage: '1',
				oneCardNum: '',
				pageSize: '10'
			},
			form: {},
			tableData: [],
			tableData2: []
		}
	},
	watch: {
		"selectForm.recordType": function (val) {
			console.log(val)
			this.$http.post("/api/oneCard/queryBatch", {
				...this.selectForm
			}).then(res => {
				this.tableData = res.data.data.list
				console.log(res)
			}).catch(err => {
				console.log(err)
			})
		}
	},
	methods: {
		handleClick() {
			if (this.activeName == "third") {
				this.getList();
			}
		},
		goBack() {
			this.$router.go(-1)
		},
		getList() {
			console.log(this.form.id)
			this.$http.post("/api/safe/passengerFlow/queryEarningById?id=" + this.form.id, {}).then(res => {
				if (res.data.code == 200) {
					this.tableData2 = res.data.data
				} else {
					this.$message.error(res.data.msg)
				}
			}).catch(err => {

			})
		}
	},
	mounted() {
		this.form = this.$route.params.val
		if (this.form.zsContractEntity.openFreeRentTime) {
			this.form.zsContractEntity.openFreeRentTimes = this.form.zsContractEntity.openFreeRentTime.replace(/；/g, ";")
		}
		if (this.form.zsContractEntity.openFreeRentTimes) {
			this.form.zsContractEntity.openFreeRentTimess = this.form.zsContractEntity.openFreeRentTimes.split(';')
		}

		this.selectForm.oneCardNum = this.form.cardNo
		this.selectForm.userId = this.form.userId
		console.log(this.$route.params.val)
		// this.getList();
	}
}
</script>

<style scoped="scoped">
.info {
	background-color: #00BFAF;
	padding: 10px;
	margin: 10px 0;
	color: white;
}

.infos {
	width: 100%;
	display: flex;
	justify-content: space-between
}

.infos>div {
	width: 30%;
	font-size: 14px;
}

.infoDetail>div {
	margin-bottom: 10px;
}

.infoDetail2>div {
	margin-bottom: 10px;
	width: 250px;
}

.infoDetail22 {
	margin-bottom: 10px;
}
</style>
